import { client, TOKEN_KEY } from "./index";

// The bell (backend routes/adminAlerts.js)
export const getAlerts = () => client.get("/admin/alerts").then((res) => res.data);
export const markAlertsRead = (ids) => client.post("/admin/alerts/read", ids ? { ids } : { all: true }).then((res) => res.data);
export const getPushKey = () => client.get("/admin/alerts/push-key").then((res) => res.data.publicKey);
export const savePushSubscription = (subscription) => client.post("/admin/alerts/push-subscriptions", subscription);
export const removePushSubscription = (endpoint) => client.delete("/admin/alerts/push-subscriptions", { data: { endpoint } });

// The live stream of new alerts (Server-Sent Events read with fetch, so the login token can go in a header).
// onEvent(name, data) for each event; resolves when the stream ends and rejects when it fails, so the caller can
// reconnect. `signal` stops it.
export async function readAlertStream(onEvent, signal) {
  const baseURL = client.defaults.baseURL || "/api";
  const res = await fetch(`${baseURL}/admin/alerts/stream`, {
    headers: { "x-auth-token": localStorage.getItem(TOKEN_KEY) || "", Accept: "text/event-stream" },
    cache: "no-store",
    signal,
  });
  if (!res.ok || !res.body) {
    const error = new Error(`Alert stream answered ${res.status}`);
    error.status = res.status;
    throw error;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    // eslint-disable-next-line no-await-in-loop -- one chunk at a time, as the server sends them
    const { value, done } = await reader.read();
    if (done) return;
    buffer += decoder.decode(value, { stream: true });
    let end = buffer.indexOf("\n\n");
    while (end !== -1) {
      const block = buffer.slice(0, end);
      buffer = buffer.slice(end + 2);
      let name = "message";
      let data = "";
      block.split("\n").forEach((line) => {
        if (line.startsWith("event: ")) name = line.slice(7);
        else if (line.startsWith("data: ")) data += line.slice(6);
      });
      if (data) {
        try { onEvent(name, JSON.parse(data)); } catch { /* a broken event is skipped */ }
      }
      end = buffer.indexOf("\n\n");
    }
  }
}
